// @todo: Migrate to @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button, type ButtonVariant} from '@wandb/weave/components/Button';
// @todo: Migrate to 'Tooltip' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Tooltip} from '@wandb/weave/components/Tooltip';
import React from 'react';
// eslint-disable-next-line wandb/no-deprecated-imports
import {type StrictPopupProps} from 'semantic-ui-react';

import {type ExcludeOutliersValues} from '../WorkspaceDrawer/Settings/types';

export type ExcludeOutliersProps = {
  buttonVariant: ButtonVariant;
  isActive: boolean;
  onClick: (val: ExcludeOutliersValues) => void;
  popupProps: StrictPopupProps;
};

export const ExcludeOutliers = ({
  buttonVariant,
  isActive,
  onClick,
  popupProps,
}: ExcludeOutliersProps) => {
  return (
    <Tooltip
      {...popupProps}
      content="Exclude extreme outliers when scaling charts"
      trigger={
        <Button
          active={isActive}
          icon="ignore-outliers"
          variant={buttonVariant}
          aria-label="Exclude extreme outliers when scaling charts"
          onClick={() => {
            onClick(isActive ? 'include-outliers' : 'exclude-outliers');
          }}
        />
      }
    />
  );
};
